/* eslint-disable react/display-name */
import React from 'react';

type Props<TProps> = JSX.IntrinsicAttributes & React.PropsWithRef<TProps & { children?: React.ReactNode }>;

/**
 *
 * @param loader A utility function to create an async component
 * @param options
 * @param options.fallback
 * @returns
 */
export function lazyLoad<TProps>(
  loader: () => Promise<{ default: React.ComponentType<TProps> }>,
  options?: { fallback?: JSX.Element | null }
): React.ComponentType<Props<TProps>> {
  const LazyComponent = React.lazy(loader) as React.ComponentType<Props<TProps>>;

  return (props: Props<TProps>) => (
    <React.Suspense fallback={options?.fallback ?? null}>
      <LazyComponent {...props} />
    </React.Suspense>
  );
}
